(() => {
  'use strict';

  if (window.__amelieLocationSelectorLoaderLoaded) return;
  window.__amelieLocationSelectorLoaderLoaded = true;

  const config = window.amelieLocationSelectorLoaderConfig;
  if (!config) return;

  let loadingPromise = null;
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';
  const cartIntentSelector = [
    'a[href*="/cart"]',
    '[data-drawer-options*="#t4s-mini_cart"]',
    '[data-drawer-open][data-id*="cart"]',
    '[data-drawer-open][data-drawer-id*="cart"]',
    '[data-action-atc]',
  ].join(',');
  const intentEvents = ['pointerdown', 'focusin'];

  function appendStylesheet(url) {
    if (!url || document.querySelector('link[data-amelie-location-style]')) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    link.dataset.amelieLocationStyle = '';
    document.head.append(link);
  }

  function appendScript(url) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.async = false;
      script.onload = resolve;
      script.onerror = () => reject(new Error(`No se pudo cargar ${url}`));
      document.head.append(script);
    });
  }

  function preloadScript(url) {
    if (!url || document.querySelector(`link[data-amelie-preload="${url}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'script';
    link.href = url;
    link.dataset.ameliePreload = url;
    document.head.append(link);
  }

  function prefetchAsset(url, as) {
    if (!url || document.querySelector(`link[data-amelie-prefetch="${url}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = as;
    link.dataset.ameliePrefetch = url;
    document.head.append(link);
  }

  function cleanupListeners() {
    document.removeEventListener('click', guardCheckoutClick, true);
    document.removeEventListener('submit', guardCheckoutSubmit, true);
    intentEvents.forEach((eventName) => {
      document.removeEventListener(eventName, handleCartIntent, true);
    });
  }

  function loadSelector() {
    if (loadingPromise) return loadingPromise;

    appendStylesheet(config.cssUrl);
    preloadScript(config.selectorUrl);
    window.wholesaleLocationSelectorConfig = config.selectorConfig;
    loadingPromise = appendScript(config.dataUrl)
      .then(() => appendScript(config.selectorUrl))
      .then(() => {
        cleanupListeners();
        return true;
      })
      .catch((error) => {
        loadingPromise = null;
        console.error('[Amelié] No se pudo cargar el selector de ubicación.', error);
        throw error;
      });
    return loadingPromise;
  }

  function stopCheckout(event, checkoutButton) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    loadSelector()
      .then(() => {
        const revealed = window.AmelieLocationSelector?.revealForCheckout?.(
          checkoutButton,
        );
        if (!revealed) {
          document.querySelector('[data-location-department], [data-location-city]')?.focus();
        }
      })
      .catch(() => undefined);
  }

  function guardCheckoutClick(event) {
    if (window.__amelieLocationSelectorLoaded) return;
    const checkoutButton = event.target.closest?.(checkoutSelector);
    if (checkoutButton) stopCheckout(event, checkoutButton);
  }

  function guardCheckoutSubmit(event) {
    if (window.__amelieLocationSelectorLoaded) return;
    if (event.submitter?.matches?.(checkoutSelector)) {
      stopCheckout(event, event.submitter);
    }
  }

  function handleCartIntent(event) {
    if (event.target.closest?.(cartIntentSelector)) loadSelector().catch(() => undefined);
  }

  function scheduleWarmup() {
    const warmup = () => {
      prefetchAsset(config.cssUrl, 'style');
      prefetchAsset(config.dataUrl, 'script');
      prefetchAsset(config.selectorUrl, 'script');
    };
    const schedule = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmup, { timeout: 5000 });
      } else {
        window.setTimeout(warmup, 2500);
      }
    };

    if (document.readyState === 'complete') {
      schedule();
    } else {
      window.addEventListener('load', schedule, { once: true });
    }
  }

  document.addEventListener('click', guardCheckoutClick, true);
  document.addEventListener('submit', guardCheckoutSubmit, true);
  intentEvents.forEach((eventName) => {
    document.addEventListener(eventName, handleCartIntent, {
      capture: true,
      passive: true,
    });
  });
  ['cart:refresh', 'cart:updated', 'cart:open'].forEach((eventName) => {
    document.addEventListener(eventName, () => loadSelector().catch(() => undefined), {
      once: true,
    });
  });

  if (config.loadImmediately) {
    loadSelector().catch(() => undefined);
  } else {
    scheduleWarmup();
  }
  window.AmelieLocationSelector = { load: loadSelector };
})();
